const $ = require("jquery");
// The reviews carousel (.reviews-block__slider) and the vertical-lp clients block
// (.vlp-clients__cards) lazy-init themselves via data-lazy-init="slick-slider"
// (see ui-components/slick-slider.js presets "reviews-block" / "vlp-clients"), so
// no eager require is needed here. Business-type cards stack on mobile on every
// category page (docs/category-page-rules.md, rule 3), so no subcat carousel either.
const { initReserveTallestTabPanel } = require("../../components/ui-components/askSimplyPanels");

$(function () {
    initReserveTallestTabPanel();
});
